import { ALL_ACCESS } from './constants';

interface BannerProps {
  activityId: string;
}

const toUpperSnakeCase = (hyphenatedString: string): string => {
  return hyphenatedString.replace(/-/g, '_').toUpperCase();
};

function Banner({ activityId }: BannerProps) {
  const activityKey = toUpperSnakeCase(activityId);
  const activity = ALL_ACCESS[activityKey as keyof typeof ALL_ACCESS];

  if (!activity) return null;

  return (
    <div
      className="relative mb-4 flex max-h-[350px] w-full max-w-[1280px] flex-row rounded-lg bg-cover bg-right p-2 md:max-h-[244px] lg:p-4"
      style={{ backgroundImage: `url(${activity.bannerImageUrl})` }}
    >
      <div className="flex w-full flex-col items-center md:flex-row md:items-center">
        <div className="max-w-28 md:max-h-36">
          <img src={activity.titleImageUrl} alt={activity.title} />
        </div>
        <div className="pt-2 text-left md:pt-0 md:pl-4">
          <div>
            <p className="text-2 leading-lg md:text-4 font-semibold text-white uppercase">
              {activity.header}
            </p>
            <p className="text-3 leading-lg md:text-5 text-white">
              {activity.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
